import regular, { IRegularDesignProps } from './Regular';

export { IRegularDesignProps };
export default regular;
